import axios from "axios";
import authStore from "../services/authStore/authStore";
import router from "../../router";

export function setupRequestInterceptors() {
  
  axios.defaults.withCredentials = false;
  axios.interceptors.request.use(function(config) {
    if (config.showLoading) {
      authStore.dispatch("showLoading");
    }
    const bearerToken = authStore.getters.userToken;
    if(router.currentRoute.value.meta.requiresAuth && !bearerToken){
      return Promise.reject(new Error('Authentication required.'));
    }
    
    if (config.externalApi) {
      // Set the base URL for requests with 'studentApi' true
      config.baseURL = config.externalApi == 'student' ? process.env.VUE_APP_STUDENT_PORTAL_API_URL : process.env.VUE_APP_CLIENTTOOL_PORTAL_API_URL;
    } else {
      // Set the default base URL for other requests
      if (bearerToken) {
        config.headers['Authorization'] = `Bearer ${bearerToken}`;
      }
      config.baseURL = process.env.VUE_APP_API_URL;
    }

    config.headers['Accept'] = 'application/json';

    if (config.method === 'get' && config.data != []) {
      // Add query parameters if needed
      config.params = config.data;
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  });
}

export function setupResponseInterceptors() {
  axios.interceptors.response.use(
    function (response) {
      authStore.dispatch("hideLoading");
      if(response?.data?.success == false){
        authStore.commit('setShowToast',['error',response.data.message,''])
      }
      else if(response?.data?.success == true && response.data.message){

        if(Array.isArray(response.data.message)){
          const messages = response.data.message;
          messages.forEach(message => {
            setTimeout(() => {
              authStore.commit('setShowToast', [message.status ? 'success' : 'error', message.message, '']);  
            }, 500);
          });
        }
        else{
          authStore.commit('setShowToast',['success',response.data.message,''])
        }
      }
      return response;
    },
    
    function(error) {
      authStore.dispatch("hideLoading");
      if (error) {
        if (error.response?.status == 401) {
          authStore.commit('logoutIsAuth401');
          return router.push("/auth/login");  
        }

        if(error.response?.data?.message){
          const message = error.response?.status == 500 ? 'Server error' : error.response?.data?.message;
          authStore.commit('setShowToast',['error',message,''])
        }
        else{
          authStore.commit('setShowToast',['error',error.message ? error.message : 'Something went wrong','Try again later'])
        }
        return error.response;
      }
    }
  );
}
